import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { trigger, style, transition, animate, keyframes } from '@angular/animations';
import { PermitVarianceService, PermitVarianceFormData } from 'src/app/services/permit-variance.service';
import { Subject } from 'rxjs';
import { takeUntil, } from 'rxjs/operators'; 
import { ApplicationPackageService, ApplicationPackage } from 'src/app/services/application-package.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-variance-form',
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('0.25s', keyframes([
          style({ height: 0, opacity: 0, offset: 0 }),
          style({ height: '*', opacity: 1, offset: 1 }),
        ]))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, }),
        animate('0.25s', keyframes([
          style({ height: '*', opacity: 1, offset: 0 }),
          style({ height: 0, opacity: 0, offset: 1 }),
        ]))
      ])
    ])
  ],
  templateUrl: './variance-form.component.html',
  styleUrls: ['./variance-form.component.scss']
})
export class VarianceFormComponent implements OnInit {

  @ViewChild('f', {static: false}) form: NgForm;

  @Input() varianceShow: boolean;
  @Input() url: string;
  @Input() printMode?: boolean = false;

  @Output() submitEvent = new EventEmitter<null>();
  @Output() hideEvent = new EventEmitter<null>();

  varianceInitial: PermitVarianceFormData;
  varianceData: PermitVarianceFormData;
  varianceSubmitted: boolean;
  editMode: boolean = true;

  applicationPackage: ApplicationPackage = null;

  private unsubscribe: Subject<any> = new Subject();

  constructor(
    private varianceService: PermitVarianceService,
    private applicationPackageService: ApplicationPackageService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    
    this.varianceInitial = {
      permitVarianceId: null,
      applicationPackageId: null,
      podId: null,
      // PermitYearId?: number,
      description: null,
      check1: false,
      check2: false,
      check3: false,
      check4: false,
      check5: false,
      check6: false,
      narrativeFile: null, // will eventually be a file upload?
      canEdit: true,
      analysisFileUploadListId: null,
      criteriaSupportFileUploadListId: null,
      useDNRReport: true
    }

    this.varianceData = this.varianceInitial;

    this.varianceService.currentVariance
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(variance => {
      if (!!variance) {
        this.varianceData = variance;
        this.submitEvent.emit();
        this.varianceSubmitted = true;
        this.editMode = false;
      } else {
        this.varianceData = this.varianceInitial;
      }
    });

    this.applicationPackageService.currentApplicationPackage
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(applicationPackage => {
      if (!!applicationPackage) {
        this.applicationPackage = applicationPackage;
      }
    });

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  submit() {
    this.silentSubmit();
    this.submitEvent.emit();
    this.hideEvent.emit();
  }

  silentSubmit() {
    if (this.varianceSubmitted === true) {
      this.varianceService.putVariance(this.varianceData, this.applicationPackage);
    } else {
      this.varianceService.postVariance(this.varianceData, this.applicationPackage);
      this.varianceSubmitted = true;
    }
    this.editMode = false;
  }

  edit() {
    this.editMode = true;
  }

  listEvent($event) {
    this.varianceData[$event.listName] = $event.listId;
    if (this.varianceSubmitted === true) this.silentSubmit();
  }

  /* Open Modal*/
  openModal(exampleVarianceNarrativeContent) {
    this.modalService.open(exampleVarianceNarrativeContent, { ariaLabelledBy: 'modal-medium', windowClass: 'modal-medium'});
  }

}
